import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useUi } from '../../../../../context/ui.context';
import { useTheme } from 'styled-components';
import { Input, Button, BackArrow, TopProgress } from '../../../../../components';
import { Container, TitleBig, CreateContainer } from './styles';

interface VolumeSettingsForm {
  volume_size_increments: number;
  volume_minimum_sizes: number;
}

const VolumeSettings: FC = () => {
  const navigate = useNavigate();
  const [t] = useTranslation();
  const { viewAlert } = useUi();
  const theme: any = useTheme();

  // Начальные значения формы
  const initialValues: VolumeSettingsForm = {
    volume_size_increments: 1,
    volume_minimum_sizes: 2,
  };

  // Схема валидации с помощью Yup
  const validationSchema = yup.object({
    volume_size_increments: yup
      .number()
      .min(1, `${t('Volume size increment must be at least 1')}`)
      .required(`${t('Volume size increment is required')}`),
    volume_minimum_sizes: yup
      .number()
      .min(1, `${t('Volume minimum size must be at least 1')}`)
      .required(`${t('Volume minimum size is required')}`),
  });

  // Инициализация Formik
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      try {
        // Формируем данные в нужном формате
        const payload = {
          volume_size_increments: {
            default: {
              __DEFAULT__: values.volume_size_increments,
            },
          },
          volume_minimum_sizes: {
            default: {
              __DEFAULT__: values.volume_minimum_sizes,
            },
          },
        };

        // Здесь должен быть вызов API для отправки данных
        // Например: await openStackService.updateVolumeSettings(payload);

        viewAlert({
          severity: 'success',
          message: t('Volume settings updated successfully'),
        });
        navigate(-1); // Возвращаемся назад после успешного сохранения
      } catch (error) {
        viewAlert({
          severity: 'error',
          message: t('Failed to update volume settings'),
        });
      }
    },
  });

  return (
      <CreateContainer>

    <Container>
          <Input
            title={t('Volume Size Increment')}
            fieldName="volume_size_increments"
            // type="number"
            value={formik.values.volume_size_increments}
            placeholder={t('Enter volume size increment')}
            customStyles={{minWidth:'550px', maxWidth:'550px'}}
          />
          <Input
            title={t('Volume Minimum Size')}
            fieldName="volume_minimum_sizes"
            // type="number"
            value={formik.values.volume_minimum_sizes}
            placeholder={t('Enter volume minimum size')}
            customStyles={{minWidth:'550px', maxWidth:'550px'}}
          />
          <Button size='display' onClick={formik.handleSubmit} title={t('SAVE')}  variant="primary" disabled={formik.isSubmitting}/>
    </Container>
            
      {formik.isSubmitting && <TopProgress />}
      </CreateContainer>

  );
};

export default VolumeSettings;